var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("booking-menu-with-budget-header", {
        attrs: { title: _vm.$t("booking.other.title") }
      }),
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { md: "3", sm: "5", cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("global.search"),
                      "append-icon": "search",
                      "hide-details": "",
                      "single-line": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.bookings,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "sort-desc": _vm.pagination.descending,
          "sort-by": _vm.pagination.sortBy
        },
        on: {
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("tr", [
                  _c("td", {}, [
                    _vm._v(_vm._s(_vm.formatDateView(item.creation_date)))
                  ]),
                  _c(
                    "td",
                    [
                      _vm._v(" " + _vm._s(item.name) + " "),
                      item.is_cancelled === 1
                        ? _c(
                            "v-chip",
                            {
                              staticStyle: {
                                color: "#FFE3F3",
                                "background-color": "#ff99d0 !important"
                              },
                              attrs: { label: "", outlined: "", small: "" }
                            },
                            [_vm._v(_vm._s(_vm.$t("booking.canceled")) + " ")]
                          )
                        : _vm._e(),
                      _c("assigned-delegations-chip", {
                        attrs: { delegations: item.delegations }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    { staticStyle: { "text-transform": "capitalize" } },
                    [_vm._v(_vm._s(item.passengers_names))]
                  ),
                  _c("td", [
                    _vm._v(
                      _vm._s(item.reservation_number) +
                        " " +
                        _vm._s(item.ticket_number)
                    )
                  ]),
                  _c(
                    "td",
                    { staticClass: "datatable-total-amount" },
                    [
                      item.invoice_gross_value !== null
                        ? [
                            _vm._v(
                              _vm._s(item.invoice_gross_value) +
                                " " +
                                _vm._s(item.invoice_currency)
                            )
                          ]
                        : item.total_amount !== null
                        ? [_vm._v(_vm._s(item.total_amount) + " PLN")]
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "td",
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            to:
                                              "/booking/other/detail/" +
                                              item.id,
                                            icon: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("remove_red_eye")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("global.goToDetails")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          staticClass: "mx-0",
                                          attrs: {
                                            disabled:
                                              _vm.$store.getters[
                                                "Ajax/loading"
                                              ],
                                            icon: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadAttachment(
                                                item.id
                                              )
                                            }
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c("v-icon", [_vm._v("cloud_download")])
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("global.downloadFile")) + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }